export default "__VITE_ASSET__BbJYDbCM__"